import { redirect, type RouteObject } from 'react-router'

import {
  createRouteModeAnchor,
  createVisitSiteAnchor,
} from '../client/components/Admin/TopNavBar/modes/index.js'
import { routeCrumb } from '../client/components/Admin/TopNavBar/utils/routeCrumb.js'

export const siteRoutes: RouteObject = {
  path: 'site',
  async lazy() {
    const { SiteRoute, SiteRouteBreadCrumb, SiteAnchorToDesign } = await import(
      '../client/components/Admin/Site/SiteRoute.js'
    )

    return {
      Component: SiteRoute,
      handle: {
        ...routeCrumb(SiteRouteBreadCrumb),
        ...createRouteModeAnchor({
          design: SiteAnchorToDesign,
        }),
      },
    }
  },
  children: [
    {
      path: 'spaces/:id',
      async lazy() {
        const {
          SpaceRouteWrapper,
          SpaceRouteWrapperAnchorToModeration,
          SpaceRouteWrapperAnchorToDesign,
          SpaceRouteWrapperAnchorToVisitSite,
          SpaceRouteWrapperBreadCrumb,
        } = await import(
          '../client/components/Admin/Site/Space/routes/SpaceRouteWrapper.js'
        )

        return {
          Component: SpaceRouteWrapper,
          handle: {
            ...routeCrumb(SpaceRouteWrapperBreadCrumb),
            ...createRouteModeAnchor({
              design: SpaceRouteWrapperAnchorToDesign,
              moderation: SpaceRouteWrapperAnchorToModeration,
            }),
            ...createVisitSiteAnchor(SpaceRouteWrapperAnchorToVisitSite),
          },
        }
      },
      children: [
        {
          index: true,
          loader: () => redirect('general'),
        },
        {
          path: 'general',
          async lazy() {
            const {
              SpaceGeneralSettingsRoute,
              SpaceGeneralSettingsRouteBreadCrumb,
            } = await import(
              '../client/components/Admin/Site/Space/routes/SpaceGeneralSettingsRoute.js'
            )

            return {
              Component: SpaceGeneralSettingsRoute,
              handle: routeCrumb(SpaceGeneralSettingsRouteBreadCrumb),
            }
          },
        },
        {
          path: 'permission',
          async lazy() {
            const {
              SpacePermissionSettingsRoute,
              SpacePermissionSettingsRouteBreadCrumb,
            } = await import(
              '../client/components/Admin/Site/Space/routes/SpacePermissionSettingsRoute.js'
            )

            return {
              Component: SpacePermissionSettingsRoute,
              handle: routeCrumb(SpacePermissionSettingsRouteBreadCrumb),
            }
          },
        },
        {
          path: 'members',
          async lazy() {
            const {
              SpaceMemberSettingsRoute,
              SpaceMemberSettingsRouteBreadCrumb,
            } = await import(
              '../client/components/Admin/Site/Space/routes/SpaceMemberSettingsRoute.js'
            )

            return {
              Component: SpaceMemberSettingsRoute,
              handle: routeCrumb(SpaceMemberSettingsRouteBreadCrumb),
            }
          },
        },
        {
          path: 'seo',
          async lazy() {
            const { SpaceSeoSettingsRoute, SpaceSeoSettingsRouteBreadCrumb } =
              await import(
                '../client/components/Admin/Site/Space/routes/SpaceSeoSettingsRoute.js'
              )

            return {
              Component: SpaceSeoSettingsRoute,
              handle: routeCrumb(SpaceSeoSettingsRouteBreadCrumb),
            }
          },
        },
        {
          path: 'localization',
          loader: () => redirect('general'),
        },
        {
          path: 'danger-zone',
          async lazy() {
            const {
              SpaceDangerZoneSettingsRoute,
              SpaceDangerZoneSettingsRouteBreadCrumb,
            } = await import(
              '../client/components/Admin/Site/Space/routes/SpaceDangerZoneSettingsRoute.js'
            )

            return {
              Component: SpaceDangerZoneSettingsRoute,
              handle: routeCrumb(SpaceDangerZoneSettingsRouteBreadCrumb),
            }
          },
        },
      ],
    },
    {
      path: 'cms/new',
      async lazy() {
        const { NewPostTypeSettingsRoute, NewPostTypeBreadCrumb } =
          await import(
            '../client/components/Admin/Site/PostType/routes/NewPostTypeSettingsRoute.js'
          )

        return {
          Component: NewPostTypeSettingsRoute,
          handle: routeCrumb(NewPostTypeBreadCrumb),
        }
      },
    },
    {
      path: 'cms/:slug',
      async lazy() {
        const { CMSRouteWrapper, CMSBreadCrumb } = await import(
          '../client/components/Admin/Site/PostType/routes/CMSRouteWrapper.js'
        )

        return {
          Component: CMSRouteWrapper,
          handle: routeCrumb(CMSBreadCrumb),
        }
      },
      children: [
        {
          path: 'settings',
          async lazy() {
            const {
              PostTypeSettingsRoute,
              PostTypeSettingsBreadCrumb,
              PostTypeSettingsAnchorToDesign,
            } = await import(
              '../client/components/Admin/Site/PostType/routes/PostTypeSettingsRoute.js'
            )

            return {
              Component: PostTypeSettingsRoute,
              handle: {
                ...routeCrumb(PostTypeSettingsBreadCrumb),
                ...createRouteModeAnchor({
                  design: PostTypeSettingsAnchorToDesign,
                }),
              },
            }
          },
        },
      ],
    },
  ],
}
